/* eslint-disable */
import packageConfig from '../../package.json';
const VERSIONS = packageConfig.version;

export default function getUserAgent() {
    const userAgent = navigator.userAgent;
    let version = 'undefined';
    let platform = 'undefined';
    const oWidth = window.screen.width;
    const oHeight = window.screen.height;
    const devicePixelRatio = window.devicePixelRatio || 1;
    const isSymbian = /(?:SymbianOS)/.test(userAgent); // 判断是否塞班
    const isIpad = /(?:iPad|PlayBook)/.test(userAgent);
    const isWindowsPhone = /(?:Windows Phone)/.test(userAgent); // 判断是否是windowsPhone
    const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;  // android终端
    const isPhone = /(?:iPhone)/.test(userAgent) && !isIpad;
    const isPc = !isPhone && !isAndroid && !isSymbian && !isWindowsPhone && !isIpad;


    /**
     *	PC端
     */
    if (isPc) {
        if (userAgent.indexOf('Firefox/') > -1) { // 判断火狐浏览器
            version = userAgent.match(/Firefox\/([\d.]+)/)[1];
            platform = 'Firefox';
        } else if (userAgent.indexOf('OPR/') > -1) { // 判断欧朋浏览器
            version = userAgent.match(/OPR\/([\d.]+)/)[1];
            platform = 'Opera';
        } else if (userAgent.indexOf('UBrowser/') > -1 && userAgent.indexOf('BIDUBrowser/') === -1) { //  判断UC浏览器
            version = userAgent.match(/UBrowser\/([\d.]+)/)[1];
            platform = 'UBrowser';
        } else if (userAgent.indexOf('BIDUBrowser/') > -1) { // 判断百度浏览器
            version = userAgent.match(/BIDUBrowser\/([\d.]+)/)[1];
            platform = 'BIDUBrowser';
        } else if (userAgent.indexOf('SE ') > -1 && userAgent.indexOf('MetaSr ') > -1) { // 判断搜狗浏览器
            version = 'undefined';
            platform = 'SogouBrowser';
        } else if (userAgent.indexOf('QQBrowser/') > -1) { // 判断QQ浏览器
            version = userAgent.match(/QQBrowser\/([\d.]+)/)[1];
            platform = 'QQBrowser';
        } else if (userAgent.indexOf('MSIE') > -1) { // 判断IE 10及其以下
            version = userAgent.match(/(MSIE\s|trident\/7)([\w\.]+)/)[2];
            platform = 'IE';
        } else if (userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:') > -1) { // 判断IE 11浏览器
            version = '11';
            platform = 'IE';
        } else if (userAgent.indexOf('Edge/') > -1) { // 判断IE Edge浏览器
            version = userAgent.match(/Edge\/([\d.]+)/)[1];
            platform = 'Edge';
        } else if (userAgent.indexOf('Chrome') > -1) { // 判断P谷歌浏览器
            version = userAgent.match(/Chrome\/([\d.]+)/)[1];
            platform = 'Chrome';
        } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1) { // 判断Safari浏览器
            version = userAgent.match(/Safari\/([\d.]+)/)[1];
            platform = 'Safari';
        }
    } else if (isPhone || isIpad) { // ipad、iphone浏览器
        if (userAgent.indexOf('UCBrowser/') > -1) { /* UCBrowser */
            version = userAgent.match(/UCBrowser\/([\d.]+)/)[1];
            platform = 'UCBrowser';
        } else if (userAgent.indexOf('baiduboxapp/') > -1) { /* 手机百度 */
            version = userAgent.match(/baiduboxapp\/([\d_\.]+)/)[1];
            version = version.split('').reverse().join('');
            while (version.indexOf('_') >= 0) {
                version = version.replace('_', '');
            }
            platform = 'baiduboxapp';
        } else if (userAgent.indexOf('baidubrowser/') > -1) { /* 百度浏览器 */
            version = userAgent.match(/baidubrowser\/([\d_\.]+)/)[1];
            platform = 'baidubrowser';
        } else if (userAgent.indexOf('FlyFlow/') > -1) { /* 百度浏览器(天书卷轴版) */
            version = userAgent.match(/FlyFlow\/([\d_\.]+)/)[1];
            platform = 'baidubrowser';
        } else if (userAgent.indexOf('BaiduHD/') > -1) { /* 百度HD */
            version = userAgent.match(/BaiduHD\/([\d_\.]+)/)[1];
            platform = 'baidubrowser';
        } else if (userAgent.indexOf('MQQBrowser/') > -1) { /* QQ浏览器 */
            version = userAgent.match(/MQQBrowser\/([\d_\.]+)/)[1];
            platform = 'MQQBrowser';
        } else if (userAgent.indexOf('MXiOS/') > -1) { /* 遨游云浏览器 */
            version = userAgent.match(/MXiOS\/([\d.]+)/)[1];
            platform = 'MxBrowser';
        } else if (userAgent.indexOf('CriOS/') > -1) { /* 谷歌浏览器 */
            version = userAgent.match(/CriOS\/([\d.]+)/)[1];
            platform = 'Chrome';
        } else if (userAgent.indexOf('FxiOS/') > -1) { /* 火狐浏览器 */
            version = userAgent.match(/FxiOS\/([\d.]+)/)[1];
            platform = 'FireFox';
        } else if (userAgent.indexOf('SogouMobileBrowser/') > -1) { /* 搜狗浏览器 */
            version = userAgent.match(/SogouMobileBrowser\/([\d.]+)/)[1];
            platform = 'SogouBrowser';
        } else if (userAgent.indexOf('QHBrowser/') > -1) { /* 360浏览器 */
            version = userAgent.match(/QHBrowser\/([\d.]+)/)[1];
            platform = '360Browser';
        } else if (userAgent.indexOf('FingerBrowser/') > -1) { /* FingerBrowser浏览器 */
            version = userAgent.match(/FingerBrowser\/([\d.]+)/)[1];
            platform = 'FingerBrowser';
        } else if (userAgent.indexOf('Safari/') === -1) { /* 欧朋浏览器 */
            // IOS无法获取浏览器版本
            version = 'undefined';
            platform = 'Opera';
        } else { /* 包括猎豹浏览器 */
            version = userAgent.match(/Safari\/([\d.]+)/)[1];
            platform = 'Safari';
        }
    } else if (isAndroid) { // Andriod手机浏览器
        if (userAgent.indexOf('UCBrowser/') > -1) { /* UCBrowser */
            version = userAgent.match(/UCBrowser\/([\d.]+)/)[1];
            platform = 'UCBrowser';
        } else if (userAgent.indexOf('baiduboxapp/') > -1) { /* 手机百度 */
            version = userAgent.match(/baiduboxapp\/([\d_\.]+)/)[1];
            platform = 'baiduboxapp';
        } else if (userAgent.indexOf('baidubrowser/') > -1) { /* 百度浏览器 */
            version = userAgent.match(/baidubrowser\/([\d_\.]+)/)[1];
            platform = 'baidubrowser';
        } else if (userAgent.indexOf('MQQBrowser/') > -1) { /* QQ浏览器 */
            version = userAgent.match(/MQQBrowser\/([\d_\.]+)/)[1];
            platform = 'MQQBrowser';
        } else if (userAgent.indexOf('Firefox/') > -1) { /* 火狐浏览器 */
            version = userAgent.match(/Firefox\/([\d.]+)/)[1];
            platform = 'FireFox';
        } else if (userAgent.indexOf('SogouMobileBrowser/') > -1) { /* 搜狗浏览器 */
            version = userAgent.match(/SogouMobileBrowser\/([\d.]+)/)[1];
            platform = 'SogouMobileBrowser';
        } else if (userAgent.indexOf('360browser') > -1) { /* 360浏览器 */
            version = 'undefined';
            platform = '360browser';
        } else if (userAgent.indexOf('FingerBrowser/') > -1) { /* FingerBrowser浏览器 */
            version = userAgent.match(/FingerBrowser\/([\d.]+)/)[1];
            platform = 'FingerBrowser';
        } else if (userAgent.indexOf('LieBaoFast/') > -1) { /* 猎豹浏览器 */
            version = userAgent.match(/LieBaoFast\/([\d.]+)/)[1];
            platform = 'LieBaoFast';
        } else if (userAgent.indexOf('MxBrowser/') > -1) { /* 遨游云浏览器 */
            version = userAgent.match(/MxBrowser\/([\d.]+)/)[1];
            platform = 'MxBrowser';
        } else if (userAgent.indexOf('Chrome/') > -1) { /* 谷歌浏览器 */
            version = userAgent.match(/Chrome\/([\d.]+)/)[1];
            platform = 'Chrome';
        } else if (userAgent.indexOf('OPR/') > -1) {  /* 欧朋浏览器 */
            version = userAgent.match(/OPR\/([\d.]+)/)[1];
            platform = 'Opear';
        }
    }
    const newWidth = devicePixelRatio * oWidth;
    const newHeight = devicePixelRatio * oHeight;
    return `BROWSER|${platform}|${version}|GAIA_WEB|${VERSIONS}|${userAgent}|${newWidth}*${newHeight}|${window.fingerPrint}`;
}
